'use client';

import { twMerge } from 'tailwind-merge';

import { Button, ButtonProps } from '@/components/Button';

export type ImagesModalControlButtonProps = ButtonProps;

export function ImagesModalControlButton({
  className,
  ...props
}: ImagesModalControlButtonProps) {
  return (
    <Button
      className={twMerge(
        'rounded-full bg-white p-2.5',
        'transition-all hover:brightness-90',
        className,
      )}
      variant="ghost"
      {...props}
    />
  );
}
